import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Icon,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Textarea,
  Tooltip,
  Select,
  HStack,
  Wrap,
  WrapItem,
  TagLabel,
  TagCloseButton,
  Tag,
  Switch,
  Box,
} from '@chakra-ui/react';
import { VscEdit } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { updateMateria } from '../../features/materiaSlice';
import { Select as ChakraReactSelect } from 'chakra-react-select';

const ModalEditarMateria = ({ row, grados, docentes, sede }) => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  // descripcionComportamental para cursos comportamentales
  const [descripcionComportamental, setdescripcionComportamental] = useState(row.descripcionComportamental || []);
  const [valoracion, setValoracion] = useState({
    id: '',
    text: '',
  });

  const initialValues = {
    _id: null,
    cursoMatriz: '',
    nombre: '',
    brand_color: '#000000',
    descripcion: '',
    orden: '',
    sede: sede,
    grado: null,
    docente: null,
    descripcionComportamental: row.descripcionComportamental || [],
    intensidadHorariaSemanal: 0,
    esComportamental: row.esComportamental || false,
    estado: '',
  };

  const [indice, setIndice] = useState(initialValues);

  const handleModalOpen = data => {
    setIsModalOpen(true);
    setIndice(data);
    setdescripcionComportamental(data.descripcionComportamental || []);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleUpdate = () => {
    dispatch(updateMateria(indice));
    setIsModalOpen(false);
  };

  const colorOptions = [
    { label: 'ROJO', value: '#FF5733' },
    { label: 'VERDE', value: '#33FF57' },
    { label: 'AZUL', value: '#3357FF' },
    { label: 'AMARILLO', value: '#FFD700' },
    { label: 'ROSADO', value: '#FF69B4' },
    { label: 'VIOLETA', value: '#8A2BE2' },
    { label: 'TURQUESA', value: '#00CED1' },
    { label: 'NARANJA', value: '#FFA500' },
    { label: 'MARRÓN', value: '#A52A2A' },
    { label: 'GRIS OSCURO', value: '#2F4F4F' },
    { label: 'CUSTOM', value: '#000000' },
  ];

  const getColorLabel = hex => {
    const found = colorOptions.find(opt => opt.value === hex);
    return found ? found.label : 'Color personalizado';
  };

  const handleAddValoracion = () => {
    if (descripcionComportamental?.length < 10 && valoracion.text.trim() !== '') {
      const newValoracion = { id: Date.now(), text: valoracion.text };
      const nuevasdescripcionComportamental = [...descripcionComportamental, newValoracion];
      setdescripcionComportamental(nuevasdescripcionComportamental);
      setIndice({ ...indice, descripcionComportamental: nuevasdescripcionComportamental });
      setValoracion({ id: '', text: '' });
    }
  }

  const handleRemoveValoracion = (id) => {
    const updateddescripcionComportamental = descripcionComportamental.filter((it) => it.id !== id);
    setdescripcionComportamental(updateddescripcionComportamental);
    setIndice({ ...indice, descripcionComportamental: updateddescripcionComportamental });
  }

  return (
    <>
      <Tooltip hasArrow label="Editar" placement="auto">
        <IconButton
          colorScheme="blackAlpha"
          _dark={{ color: 'white', _hover: { bg: 'whiteAlpha.200' } }}
          aria-label="Editar"
          isRound
          icon={<Icon as={VscEdit} fontSize="2xl" />}
          variant={'solid'}
          onClick={() => handleModalOpen(row)}
          ml={2}
        />
      </Tooltip>
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        size="full"
      >
        <ModalOverlay
          bg="rgba(11,15,25, 0.8)"
          backdropFilter="auto"
          backdropBlur="2px"
        />
        <ModalContent _dark={{ bg: 'primary.1000' }}>
          <ModalHeader textAlign="center">ACTUALIZAR ASIGNATURA</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack
              spacing={4}
              direction="column"
              justifyContent="space-between"
              p={4}
            >
              <Stack spacing={4} direction="row" justifyContent="space-between">
                <FormControl>
                  <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                  <Input
                    defaultValue={indice ? indice.nombre : ''}
                    placeholder="Escribe el nombre de la materia"
                    type="text"
                    onChange={e =>
                      setIndice({ ...indice, nombre: e.target.value })
                    }
                  />
                </FormControl>
                <FormControl w="50%">
                  <FormLabel fontWeight="semibold">COLOR</FormLabel>
                  <ChakraReactSelect
                    options={colorOptions}
                    value={{
                      label: getColorLabel(indice.brand_color),
                      value: indice.brand_color,
                    }}
                    onChange={option =>
                      setIndice({ ...indice, brand_color: option.value })
                    }
                    isSearchable={false}
                    getOptionLabel={e => (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div
                          style={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            backgroundColor: e.value,
                          }}
                        />
                        {e.label}
                      </div>
                    )}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">N. ORDEN</FormLabel>
                  <Input
                    type="number"
                    onChange={e => setIndice({ ...indice, orden: e.target.value })}
                    placeholder="Orden del Curso"
                    defaultValue={indice ? indice.orden : ''}
                  />
                </FormControl>
              </Stack>
              <Stack spacing={4} direction="row" justifyContent="space-between">
                <FormControl isRequired>
                  <FormLabel fontWeight="semibold">DESCRIPCIÓN</FormLabel>
                  <Textarea
                    placeholder="DESCRIPCIÓN"
                    type="text"
                    defaultValue={indice ? indice.descripcion : ''}
                    onChange={e =>
                      setIndice({ ...indice, descripcion: e.target.value })
                    }
                  />
                </FormControl>
              </Stack>

              {/* Switch para curso comportamental */}
              <Box
                p={4}
                borderWidth="2px"
                borderRadius="lg"
                borderColor={indice.esComportamental ? 'primary.500' : 'gray.200'}
                bg={indice.esComportamental ? 'primary.50' : 'transparent'}
                _dark={{
                  borderColor: indice.esComportamental ? 'primary.300' : 'gray.600',
                  bg: indice.esComportamental ? 'primary.900' : 'transparent',
                }}
              >
                <FormControl display="flex" alignItems="center">
                  <FormLabel htmlFor="es-comportamental" mb="0" fontWeight="bold">
                    ¿Es un curso comportamental?
                  </FormLabel>
                  <Switch
                    id="es-comportamental"
                    size="lg"
                    colorScheme="primary"
                    isChecked={indice.esComportamental}
                    onChange={e => {
                      setIndice({ ...indice, esComportamental: e.target.checked });
                      // Limpiar campos cuando cambia el modo
                      if (e.target.checked) {
                        setIndice({ ...indice, esComportamental: true, intensidadHorariaSemanal: 0 });
                      } else {
                        setdescripcionComportamental([]);
                        setIndice({ ...indice, esComportamental: false, descripcionComportamental: [] });
                      }
                    }}
                  />
                </FormControl>
                {indice.esComportamental && (
                  <Text fontSize="sm" color="gray.600" _dark={{ color: 'gray.400' }} mt={2}>
                    Los cursos comportamentales solo requieren descripcionComportamental cualitativas
                  </Text>
                )}
              </Box>
              {/* Campos condicionales según el tipo de curso */}
              {!indice.esComportamental ? (
                <>
                  <Stack direction="row" justifyContent="space-between">
                    <FormControl>
                      <FormLabel fontWeight="semibold">GRADO</FormLabel>
                      <Select
                        placeholder="SELECCIONE EL GRADO"
                        onChange={e =>
                          setIndice({ ...indice, grado: e.target.value })
                        }
                        defaultValue={indice ? indice.grado?._id : ''}
                      >
                        {grados.map(grado => (
                          <option key={grado._id} value={grado._id}>
                            {grado.nombre} - {grado.nivel}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        INTENSIDAD HORARIA SEMANAL
                      </FormLabel>
                      <Input
                        placeholder="Intensidad horaria semanal"
                        defaultValue={indice ? indice.intensidadHorariaSemanal : ''}
                        type="number"
                        onChange={e =>
                          setIndice({
                            ...indice,
                            intensidadHorariaSemanal: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between">
                    <FormControl>
                      <FormLabel fontWeight="semibold">ASIGNAR DOCENTE</FormLabel>
                      <Select
                        placeholder="SELECCIONE EL DOCENTE"
                        onChange={e =>
                          setIndice({ ...indice, docente: e.target.value })
                        }
                        defaultValue={indice ? indice?.docente?._id : ''}
                        colorScheme="primary"
                        size="lg"
                      >
                        {docentes.map(docente => (
                          <option key={docente._id} value={docente._id}>
                            {docente.nombre}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>
                </>
              ) : (
                <>
                  {/* Sección de descripcionComportamental para cursos comportamentales */}
                  <Stack direction="row" justifyContent="space-between">
                    <FormControl>
                      <FormLabel fontWeight="semibold">GRADO</FormLabel>
                      <Select
                        placeholder="SELECCIONE EL GRADO"
                        onChange={e =>
                          setIndice({ ...indice, grado: e.target.value })
                        }
                        defaultValue={indice ? indice.grado?._id : ''}
                      >
                        {grados.map(grado => (
                          <option key={grado._id} value={grado._id}>
                            {grado.nombre} - {grado.nivel}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between">
                    <FormControl>
                      <FormLabel fontWeight="semibold">ASIGNAR DOCENTE</FormLabel>
                      <Select
                        placeholder="SELECCIONE EL DOCENTE"
                        onChange={e =>
                          setIndice({ ...indice, docente: e.target.value })
                        }
                        defaultValue={indice ? indice?.docente?._id : ''}
                        colorScheme="primary"
                        size="lg"
                      >
                        {docentes.map(docente => (
                          <option key={docente._id} value={docente._id}>
                            {docente.nombre}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>

                  <Stack spacing={4}>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Descripcion Comportamental <Text as="span" fontWeight="normal">({descripcionComportamental?.length}/4)</Text>
                      </FormLabel>

                      <HStack>
                        <Input
                          placeholder="Escribe una descripcion del comportamiento para la materia"
                          type="text"
                          value={valoracion.text}
                          onChange={(e) => setValoracion({ ...valoracion, text: e.target.value })}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              handleAddValoracion();
                            }
                          }}
                          maxLength={100}
                          aria-label="input-valoracion"
                        />
                        <Button
                          colorScheme="primary"
                          onClick={handleAddValoracion}
                          isDisabled={descripcionComportamental?.length >= 4}
                        >
                          Agregar
                        </Button>
                      </HStack>
                    </FormControl>

                    {indice?.descripcionComportamental?.length > 0 && (
                      <Wrap>
                        {indice.descripcionComportamental.map((val) => (
                          <WrapItem key={val.id}>
                            <Tag size="lg" borderRadius="full" variant="solid" colorScheme="primary">
                              <TagLabel>{val.text}</TagLabel>
                              <TagCloseButton onClick={() => handleRemoveValoracion(val.id)} aria-label={`Eliminar ${val.text}`} />
                            </Tag>
                          </WrapItem>
                        ))}
                      </Wrap>
                    )}
                  </Stack>
                </>
              )}
              <Stack direction="row" justifyContent="space-between" w="full">
                <Text fontWeight="semibold">ESTADO</Text>
                <RadioGroup
                  onChange={e => setIndice({ ...indice, estado: e })}
                  defaultValue={indice ? indice.estado : ''}
                  colorScheme="primary"
                  size="lg"
                >
                  <Stack direction="row">
                    <Radio value="activo">Activo</Radio>
                    <Radio value="inactivo">Inactivo</Radio>
                  </Stack>
                </RadioGroup>
              </Stack>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button
              size="lg"
              mr={3}
              onClick={handleModalClose}
              borderRadius="xl"
            >
              CANCELAR
            </Button>
            <Button
              colorScheme="primary"
              _dark={{
                bg: 'primary.100',
                color: 'white',
                _hover: { bg: 'primary.300' },
              }}
              size="lg"
              mr={3}
              onClick={handleUpdate}
              borderRadius="xl"
            >
              ACTUALIZAR
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalEditarMateria;